// extracted by mini-css-extract-plugin
export default {"support-access__search":"SupportAccess_support-access__search__ihUgk"};